import React from 'react';
import './styles.themed.scss';
/**
 * InlineVideoPlaceHolder
 *
 * Presentational mount point for inline videos.
 * Renders a non-interactive div with styling hooks and a test id.
 *
 * @returns {JSX.Element}
 */
export function InlineVideoPlaceHolder() {
  return (
    <div
      className="inline-video placeholder"
      data-testid="inline-video-placeholder"
    />
  );
}
